module.exports = __webpack_public_path__ + "img/kf-ava.2d09c5ef.png";